<template>
    <pop-up-modal-content
        :maxWidth="settings.max_width"
        :maxHeight="settings.max_height"
        :backgroundColor="settings.background_color"
        :justifyContentPopUp="settings.justify_content"
        :alignItemsPopUp="settings.align_items"
        :marginPopUp="settings.margin"

        :paddingPopUpHeader="settings.header.padding"
        :borderWidthPopUpHeader="settings.header.border.border_width"
        :borderColorPopUpHeader="settings.header.border.border_color"
        :borderStylePopUpHeader="settings.header.border.border_style"

        :paddingPopUpBody="settings.body.padding"
        :overflowBodyPopUp="settings.body.overflow"

        :paddingPopUpFooter="settings.footer.padding"
        :justifyContentPopUpFooter="settings.footer.justify_content"
        :borderWidthPopUpFooter="settings.footer.border.border_width"
        :borderColorPopUpFooter="settings.footer.border.border_color"
        :borderStylePopUpFooter="settings.footer.border.border_style"

        :textAlignTitle="settings.title.text_align"
        :textTransformTitle="settings.title.text_transform"
        :fontSizeTitle="settings.title.font_size"
        :fontWeightTitle="settings.title.font_weight"
        :fontFamilyTitle="settings.title.font_family"
        :colorTitle="settings.title.color"
        :marginTitle="settings.title.margin"
        :whiteSpaceTitle="settings.title.white_space"
        :letterSpacingTitle="settings.title.letter_spacing"
        :lineHeightTitle="settings.title.line_height"

        :textAlignDescription="settings.description.text_align"
        :textTransformDescription="settings.description.text_transform"
        :fontSizeDescription="settings.description.font_size"
        :fontWeightDescription="settings.description.font_weight"
        :fontFamilyDescription="settings.description.font_family"
        :colorDescription="settings.description.color"
        :marginDescription="settings.description.margin"
        :letterSpacingDescription="settings.description.letter_spacing"
        :lineHeightDescription="settings.description.line_height"

        :bgBtnSign="settings.buttons.btn_sign.background_color"
        :colorBtnSign="settings.buttons.btn_sign.color"
        :borderColorBtnSign="settings.buttons.btn_sign.border_color"
        :bgHoverBtnSign="settings.buttons.btn_sign.background_color_hover"
        :colorHoverBtnSign="settings.buttons.btn_sign.color_hover"
        :borderHoverColorBtnSign="settings.buttons.btn_sign.border_color_hover"
        
        :bgBtnYes="settings.buttons.btn_yes.background_color"
        :colorBtnYes="settings.buttons.btn_yes.color"
        :borderColorBtnYes="settings.buttons.btn_yes.border_color"
        :bgHoverBtnYes="settings.buttons.btn_yes.background_color_hover"
        :colorHoverBtnYes="settings.buttons.btn_yes.color_hover"
        :borderHoverColorBtnYes="settings.buttons.btn_yes.border_color_hover"

        :bgBtnNo="settings.buttons.btn_no.background_color"
        :colorBtnNo="settings.buttons.btn_no.color"
        :borderColorBtnNo="settings.buttons.btn_no.border_color"
        :bgHoverBtnNo="settings.buttons.btn_no.background_color_hover"
        :colorHoverBtnNo="settings.buttons.btn_no.color_hover"
        :borderHoverColorBtnNo="settings.buttons.btn_no.border_color_hover"

        :borderRadiusButton="settings.buttons.border.border_radius"
        :borderWidthButton="settings.buttons.border.border_width"
        :borderStyleButton="settings.buttons.border.border_style"
        :fontSizeButton="settings.buttons.font_size"
        :fontWeightButton="settings.buttons.font_weight"
        :fontFamilyButton="settings.buttons.font_family"
        :textTransformButton="settings.buttons.text_transform"
        :letterSpacingButton="settings.buttons.letter_spacing"
        :paddingButton="settings.buttons.padding"
        :marginButton="settings.buttons.margin"
        
        :bgInput="settings.inputs.background_color"
        :colorInput="settings.inputs.color"
        :fontSizeInput="settings.inputs.font_size"
        :fontWeightInput="settings.inputs.font_weight"
        :letterSpacingInput="settings.inputs.letter_spacing"
        :paddingInput="settings.inputs.padding"
        :marginInput="settings.inputs.margin"
        :borderRadiusInput="settings.inputs.border.border_radius"
        :borderWidthInput="settings.inputs.border.border_width"
        :borderStyleInput="settings.inputs.border.border_style"
        :borderColorInput="settings.inputs.border.border_color"
     
        :flexDirectionContent="settings.body.content.flex_direction"
        :alignItemsContent="settings.body.content.align_items"
        :justifyContentContent="settings.body.content.justify_content"
        :paddingContent="settings.body.content.padding"
    >
        <div class="modal show" id="modal_pop_up_newsletter" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" @click="closeModal()">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-body">
                        <div class="news-header">
                            <button type="button" class="close" @click="closeModal()" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <template v-if="pop_up.url_image">
                            <img
                                :class="[
                                    settings.body.image.locale == 'left' ? `float-left ${settings.body.image.width}` :
                                    settings.body.image.locale == 'right' ? `float-right ${settings.body.image.width}` : 'all w-100'
                                ]"
                                :src="pop_up.url_image"
                                loading="lazy"
                            >
                        </template>
                        
                        <div :class="[
                                settings.body.content.locale == 'right' ? `float-right ${settings.body.content.width}` :
                                settings.body.content.locale == 'left' ? `float-left ${settings.body.content.width}` : 'all w-100',
                                'pop-up-content'
                            ]">
                            <template v-if="pop_up.title">
                                <h3 v-html="pop_up.title"></h3>
                            </template>
                            <template v-if="pop_up.description">
                                <div class="div-description" v-html="pop_up.description"></div>
                            </template>
                            <div :class="['form-group', settings.inputs.width]">
                                <div class="col w-100">
                                    <input type="text" placeholder="Email" autocomplete="off">
                                </div>
                                <button type="button" class="btn-sign">Assinar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </pop-up-modal-content>
</template>

<script>
import { CPopUpModalContent } from '../Styles/PopUp/styled'

export default {
    name: 'PopUpNewsletter',
    props: {
        pop_up: { required: true },
        set: { required: true },
        show_popup: { required: true }
    },
    components: {
        'pop-up-modal-content': CPopUpModalContent
    },
    data() {
        return {
            settings: {
                max_width: this.set?.max_width ?? '600px',
                max_height: this.set?.max_height ?? 'auto',
                background_color: this.set?.background_color ?? '#ffffff',
                justify_content: this.set?.justify_content ?? 'center',
                align_items: this.set?.align_items ?? 'start',
                margin: this.set?.margin ?? '20px',
                
                header: {
                    padding: this.set?.header?.padding ?? '1.5rem',
                    border: {
                        border_width: this.set?.header?.border?.border_width ?? '0',
                        border_color: this.set?.header?.border?.border_color ?? '#000',
                        border_style: this.set?.header?.border?.border_style ?? 'solid'
                    }
                },
                body: {
                    padding: this.set?.body?.padding ?? '0px',
                    overflow: this.set?.body?.overflow ?? 'hidden',
                    image: {
                        locale: this.set?.body?.image?.locale ?? 'all',
                        width: this.set?.body?.image?.width ?? 'w-100'
                    },
                    content: {
                        locale: this.set?.body?.content?.locale ?? 'all',
                        width: this.set?.body?.content?.width ?? 'w-100',
                        flex_direction: this.set?.body?.content?.flex_direction ?? 'column',
                        align_items: this.set?.body?.content?.align_items ?? 'center',
                        justify_content: this.set?.body?.content?.justify_content ?? 'center',
                        padding: this.set?.body?.content?.padding ?? '15px'
                    }
                },
                footer: {
                    padding: this.set?.footer?.padding ?? '0px',
                    justify_content: this.set?.footer?.justify_content ?? 'end',
                    border: {
                        border_width: this.set?.footer?.border?.border_width ?? '0',
                        border_color: this.set?.footer?.border?.border_color ?? '#000',
                        border_style: this.set?.footer?.border?.border_style ?? 'solid'
                    }
                },
                title: {
                    text_align: this.set?.title?.text_align ?? 'center',
                    text_transform: this.set?.title?.text_transform ?? 'initial',
                    font_size: this.set?.title?.font_size ?? '2rem',
                    font_weight: this.set?.title?.font_weight ?? '400',
                    font_family: this.set?.title?.font_family ?? 'Oswald',
                    color: this.set?.title?.color ?? '#484848',
                    margin: this.set?.title?.margin ?? '0 0 20px 0',
                    white_space: this.set?.title?.white_space ?? 'wrap',
                    letter_spacing: this.set?.title?.letter_spacing ?? '1px',
                    line_height: this.set?.title?.line_height ?? '1.3'
                },
                description: {
                    text_align: this.set?.description?.text_align ?? 'center',
                    text_transform: this.set?.description?.text_transform ?? 'initial',
                    font_size: this.set?.description?.font_size ?? '1.3rem',
                    font_weight: this.set?.description?.font_weight ?? '500',
                    font_family: this.set?.description?.font_family ?? 'Open Sans',
                    color: this.set?.description?.color ?? '#222F3D',
                    margin: this.set?.description?.margin ?? '0',
                    letter_spacing: this.set?.description?.letter_spacing ?? '0.3px',
                    line_height: this.set?.description?.line_height ?? '1.8'
                },
                buttons: {
                    font_size: this.set?.buttons?.font_size ?? '1.4rem',
                    font_weight: this.set?.buttons?.font_weight ?? '400',
                    font_family: this.set?.buttons?.font_family ?? 'Oswald',
                    text_transform: this.set?.buttons?.text_transform ?? 'uppercase',
                    letter_spacing: this.set?.buttons?.letter_spacing ?? '1px',
                    padding: this.set?.buttons?.padding ?? '.4rem 1.8rem',
                    margin: this.set?.buttons?.margin ?? '0px',
                    border: {
                        border_radius: this.set?.buttons?.border?.border_radius ?? '0.25rem',
                        border_width: this.set?.buttons?.border?.border_width ?? '1px',
                        border_style: this.set?.buttons?.border?.border_style ?? 'solid'
                    },
                    btn_yes: {
                        background_color: this.set?.buttons?.btn_yes?.background_color ?? '#484848',
                        color: this.set?.buttons?.btn_yes?.color ?? '#ffffff',
                        border_color: this.set?.buttons?.btn_yes?.border_color ?? '#484848',
                        background_color_hover: this.set?.buttons?.btn_yes?.background_color_hover ?? this.set.buttons.btn_yes.background_color,
                        color_hover: this.set?.buttons?.btn_yes?.color_hover ?? this.set.buttons.btn_yes.color,
                        border_color_hover: this.set?.buttons?.btn_yes?.border_color_hover ?? this.set.buttons.btn_yes.border_color
                    },
                    btn_no: {
                        background_color: this.set?.buttons?.btn_no?.background_color ?? '#dddddd',
                        color: this.set?.buttons?.btn_no?.color ?? '#555555',
                        border_color: this.set?.buttons?.btn_no?.border_color ?? '#dddddd',
                        background_color_hover: this.set?.buttons?.btn_no?.background_color_hover ?? this.set.buttons.btn_no.background_color,
                        color_hover: this.set?.buttons?.btn_no?.color_hover ?? this.set.buttons.btn_no.color,
                        border_color_hover: this.set?.buttons?.btn_no?.border_color_hover ?? this.set.buttons.btn_no.border_color
                    },
                    btn_sign: {
                        background_color: this.set?.buttons?.btn_sign?.background_color ?? '#222F3D',
                        color: this.set?.buttons?.btn_sign?.color ?? '#fff',
                        border_color: this.set?.buttons?.btn_sign?.border_color ?? '#222F3D',
                        background_color_hover: this.set?.buttons?.btn_sign?.background_color_hover ?? this.set.buttons.btn_sign.background_color,
                        color_hover: this.set?.buttons?.btn_sign?.color_hover ?? this.set.buttons.btn_sign.color,
                        border_color_hover: this.set?.buttons?.btn_sign?.border_color_hover ?? this.set.buttons.btn_sign.border_color
                    }
                },
                inputs: {
                    background_color: this.set?.inputs?.background_color ?? 'transparent',
                    color: this.set?.inputs?.color ?? '#222F3D',
                    font_size: this.set?.inputs?.font_size ?? '1.3rem',
                    font_weight: this.set?.inputs?.font_weight ?? '400',
                    letter_spacing: this.set?.inputs?.letter_spacing ?? '0.2px',
                    padding: this.set?.inputs?.padding ?? '0.25rem 0.8rem',
                    margin: this.set?.inputs?.margin ?? '0',
                    width: this.set?.inputs?.width ?? 'w-100',
                    border: {
                        border_radius: this.set?.inputs?.border?.border_radius ?? '0',
                        border_width: this.set?.inputs?.border?.border_width ?? '0 0 1px 0',
                        border_style: this.set?.inputs?.border?.border_style ?? 'solid',
                        border_color: this.set?.inputs?.border?.border_color ?? '#222F3D'
                    }
                }
            }
        }
    },
    mounted() {
        $('#modal_pop_up_newsletter').show()
    },
    methods: {
        closeModal() {
            $('#modal_pop_up_newsletter').hide()
        }
    }
}
</script>